import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import SecurityHelper from '../src/utils/security';

// a check() for the requireCurrentUser HOC to ensure the user has writeAccess
const hasWriteAccess = (user) => user.apiKey.writeAccess;

// a check() for the requireCurrentUser HOC to ensure the user has adminAccess
const hasAdminAccess = (user) => user.apiKey.adminAccess;

export default function ProtectedRoute(props) {
    const { requiresWriteAccess, requiresAdminAccess } = props;
    const isLoggedIn = SecurityHelper.isLoggedIn();
    const user = SecurityHelper.user();

    const hasCorrectWritePermissions = requiresWriteAccess
        ? isLoggedIn && hasWriteAccess(user)
        : isLoggedIn;

    const hasCorrectAdminPermissions = requiresAdminAccess
        ? isLoggedIn && hasAdminAccess(user)
        : isLoggedIn;

    if (isLoggedIn && hasCorrectWritePermissions && hasCorrectAdminPermissions) {
        return <Route {...props} />
    }

    return <Redirect to="/" />;
}

ProtectedRoute.propTypes = {
    requiresWriteAccess: PropTypes.bool,
    requiresAdminAccess: PropTypes.bool
};